import "./Detail.css";
import { motion } from "framer-motion";

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};

const item = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5 } }
};

function Detail() {
  return (
    <main className="about-page">

      {/* HERO */}
      <motion.header
        className="about-hero"
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
      >
        <div className="about-hero-inner">
          <h1 className="about-hero-title">Welcome to InfoStream</h1>
          <p className="about-hero-tagline">
            Smart news aggregation designed for the modern reader.
          </p>
          <p className="about-hero-sub">
            Discover reliable stories and stay informed without the noise.
          </p>
        </div>
        <div className="about-hero-wave" />
      </motion.header>

      {/* INTRO */}
      <motion.section
        className="about-section about-intro"
        variants={container}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true }}
      >
        <motion.h2 variants={item}>What is InfoStream?</motion.h2>
        <motion.p variants={item}>
          InfoStream is a modern news platform that collects stories from
          trusted global sources and delivers them in a clean,
          personalized feed.
        </motion.p>
      </motion.section>

      {/* VISION */}
      <motion.section
        className="about-section about-vision"
        variants={container}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true }}
      >
        <div className="about-split">
          <motion.div variants={item}>
            <h2>Our Vision</h2>
            <p>
              A world where accurate information is accessible to everyone.
            </p>
          </motion.div>

          <motion.div variants={item}>
            <h2>Our Mission</h2>
            <p>
              Deliver curated and reliable news using real-time aggregation
              and smart filtering.
            </p>
          </motion.div>
        </div>
      </motion.section>

      {/* FEATURES */}
      <motion.section
        className="about-section about-highlights"
        variants={container}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true }}
      >
        <motion.h2 variants={item}>Platform Features</motion.h2>

        <div className="about-card-grid">
          <motion.article className="about-card" variants={item}>
            <h3>Personalized Feed</h3>
            <p>Your homepage adapts to topics you follow.</p>
          </motion.article>

          <motion.article className="about-card" variants={item}>
            <h3>Trusted Sources</h3>
            <p>News from reliable global publications.</p>
          </motion.article>

          <motion.article className="about-card" variants={item}>
            <h3>Save Favorites</h3>
            <p>Bookmark stories and read them anytime.</p>
          </motion.article>

          <motion.article className="about-card" variants={item}>
            <h3>Fast Experience</h3>
            <p>Built with modern technologies for speed.</p>
          </motion.article>
        </div>
      </motion.section>

      {/* STATS */}
      <motion.section
        className="about-section about-stats"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      >
        <h2>InfoStream at a Glance</h2>

        <ul className="about-stats-list">
          <motion.li initial={{ scale: 0.8 }} whileInView={{ scale: 1 }}>
            <span className="about-stat-number">120+</span>
            <span className="about-stat-label">Sources</span>
          </motion.li>

          <motion.li initial={{ scale: 0.8 }} whileInView={{ scale: 1 }}>
            <span className="about-stat-number">1.5M+</span>
            <span className="about-stat-label">Articles</span>
          </motion.li>

          <motion.li initial={{ scale: 0.8 }} whileInView={{ scale: 1 }}>
            <span className="about-stat-number">24/7</span>
            <span className="about-stat-label">Updates</span>
          </motion.li>
        </ul>
      </motion.section>

      {/* CTA */}
      <motion.section
        className="about-section about-cta"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      >
        <h2>Start Your Personalized News Feed</h2>
        <p>Create an account and build your own information stream.</p>

        <motion.a
          href="/register"
          className="about-cta-button"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          Create Free Account
        </motion.a>
      </motion.section>

    </main>
  );
}

export default Detail;